var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thirdWrap"},[_c('GoBack',{attrs:{"title":_vm.title,"nextPath":_vm.$route.query.nextPath,"curSelectTab":_vm.$route.query.curSelectTab}}),(_vm.title === '可捐衣物匹配' || _vm.title === '可捐物品匹配')?_c('Matching',{attrs:{"title":_vm.title}}):_vm._e(),(_vm.title.includes('地址'))?_c('AddressEdit'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }